export function toWhatsAppPhone(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("62")) return digits;
  if (digits.startsWith("0")) return `62${digits.slice(1)}`;
  return digits;
}

export function toWhatsAppUrl(raw) {
  const phone = toWhatsAppPhone(raw);
  return phone ? `https://wa.me/${phone}` : "";
}
